import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import {assert} from 'Asserts';
// @ts-expect-error
import FilesPicker from 'components/FilesPicker';
import getTestProps from 'test/lib/cypress/getTestProps';

interface FilesPickerComponentProps {
  isDisabled?: boolean;
  getName?: Function;
  multiple?: boolean;
  // If bulkUpload is true, all the files will be sent as a list
  // to the upload function and the component expects a single
  // promise indicating whether the bulk upload succeeded
  bulkUpload?: boolean;
  parallelism?: number;
  upload: (files: Array<File>) => JQueryPromise<void>;
  maxFiles?: number;
  fileTypes?: Array<string>;
}

interface State {
  filesPicker: FilesPicker | null;
}

export default class FilesPickerComponent extends React.Component<FilesPickerComponentProps, State> {
  override state: State = {
    filesPicker: null,
  };

  override componentDidMount(): void {
    const filesPicker = new FilesPicker(this.props);
    this.setState({filesPicker}, this.renderFilesPicker);
  }

  override componentWillUnmount(): void {
    if (this.state.filesPicker != null) {
      this.state.filesPicker.remove();
    }
  }

  handleUpload({
    uploadComplete,
    allComplete,
  }: {
    uploadComplete?: () => void;
    allComplete?: () => void;
  }): JQueryDeferred<void> {
    assert(this.state.filesPicker != null, `Called upload on filesPicker=${this.state.filesPicker}`);
    return this.state.filesPicker.handleUpload({uploadComplete, allComplete});
  }

  renderFilesPicker = (): void => {
    $(ReactDOM.findDOMNode(this)!).empty().append(this.state.filesPicker.render().el);
  };

  override render(): JSX.Element {
    return <div {...getTestProps({component: 'FilesPickerComponent', element: 'root'})} />;
  }
}
